<template>
  <div class="empty">
    <img :src="getImageUrlWithCDN_TEST('/empty/empty.png')" :style="styleVars" />
    <span class="text">
      <slot name="text">{{ $t('noData') }}</slot>
    </span>
  </div>
</template>

<script setup>
const props = defineProps({
  width: {
    type: [String, Number],
    default: '100%',
  },
  // height: {
  //   type: [String, Number],
  //   default: '200px',
  // },
})
// 处理宽度，数字自动添加px单位
const formattedWidth = computed(() => {
  if (typeof props.width === 'number') {
    return `${props.width}px`
  }
  return props.width
})

// 处理高度，数字自动添加px单位
const formattedHeight = computed(() => {
  if (typeof props.height === 'number') {
    return `${props.height}px`
  }
  return props.height
})
// 创建CSS变量对象供样式使用[6,7](@ref)
const styleVars = computed(() => ({
  '--empty-width': formattedWidth.value,
  // '--empty-height': formattedHeight.value,
}))
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    max-width: var(--empty-width, 100%);
  }
  .text {
    color: var(--icon-empty);
    font-size: 13px;
    margin-top: 13px;
  }
}
</style>
